// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../fetch.pb.js";
export var AddOnLineItems;
(function (AddOnLineItems) {
    AddOnLineItems["ADD_ON_LINE_ITEM_UNSPECIFIED"] = "ADD_ON_LINE_ITEM_UNSPECIFIED";
    AddOnLineItems["ADD_ON_LINE_ITEM_DIGITISATION_FEE"] = "ADD_ON_LINE_ITEM_DIGITISATION_FEE";
    AddOnLineItems["ADD_ON_LINE_ITEM_ADDITIONAL_FORM_DIGITISATION_FEE"] = "ADD_ON_LINE_ITEM_ADDITIONAL_FORM_DIGITISATION_FEE";
})(AddOnLineItems || (AddOnLineItems = {}));
export var AddOnLineItems_index;
(function (AddOnLineItems_index) {
    AddOnLineItems_index[AddOnLineItems_index["ADD_ON_LINE_ITEM_UNSPECIFIED"] = 0] = "ADD_ON_LINE_ITEM_UNSPECIFIED";
    AddOnLineItems_index[AddOnLineItems_index["ADD_ON_LINE_ITEM_DIGITISATION_FEE"] = 1] = "ADD_ON_LINE_ITEM_DIGITISATION_FEE";
    AddOnLineItems_index[AddOnLineItems_index["ADD_ON_LINE_ITEM_ADDITIONAL_FORM_DIGITISATION_FEE"] = 2] = "ADD_ON_LINE_ITEM_ADDITIONAL_FORM_DIGITISATION_FEE";
})(AddOnLineItems_index || (AddOnLineItems_index = {}));
// SubscriptionAddOnEnums will help in identifying the type of subscription card to render in UI.
// This can be multiple in case of Bulk Messaging (for different tiers), thus using a common card identifier using enums. 
export var SubscriptionAddOnEnums;
(function (SubscriptionAddOnEnums) {
    SubscriptionAddOnEnums["SUBSCRIPTION_ADDON_UNSPECIFIED"] = "SUBSCRIPTION_ADDON_UNSPECIFIED";
    SubscriptionAddOnEnums["SUBSCRIPTION_ADDON_ONLINE_SCHEDULING"] = "SUBSCRIPTION_ADDON_ONLINE_SCHEDULING";
    SubscriptionAddOnEnums["SUBSCRIPTION_ADDON_DIGITAL_FORMS"] = "SUBSCRIPTION_ADDON_DIGITAL_FORMS";
    SubscriptionAddOnEnums["SUBSCRIPTION_ADDON_PRACTICE_ANALYTICS"] = "SUBSCRIPTION_ADDON_PRACTICE_ANALYTICS";
    SubscriptionAddOnEnums["SUBSCRIPTION_ADDON_WEAVE_VERIFY"] = "SUBSCRIPTION_ADDON_WEAVE_VERIFY";
    SubscriptionAddOnEnums["SUBSCRIPTION_ADDON_CALL_INTELLIGENCE"] = "SUBSCRIPTION_ADDON_CALL_INTELLIGENCE";
    SubscriptionAddOnEnums["SUBSCRIPTION_ADDON_TEXT_CONNECT"] = "SUBSCRIPTION_ADDON_TEXT_CONNECT";
    SubscriptionAddOnEnums["SUBSCRIPTION_ADDON_BULK_MESSAGING"] = "SUBSCRIPTION_ADDON_BULK_MESSAGING";
})(SubscriptionAddOnEnums || (SubscriptionAddOnEnums = {}));
export var SubscriptionAddOnEnums_index;
(function (SubscriptionAddOnEnums_index) {
    SubscriptionAddOnEnums_index[SubscriptionAddOnEnums_index["SUBSCRIPTION_ADDON_UNSPECIFIED"] = 0] = "SUBSCRIPTION_ADDON_UNSPECIFIED";
    SubscriptionAddOnEnums_index[SubscriptionAddOnEnums_index["SUBSCRIPTION_ADDON_ONLINE_SCHEDULING"] = 1] = "SUBSCRIPTION_ADDON_ONLINE_SCHEDULING";
    SubscriptionAddOnEnums_index[SubscriptionAddOnEnums_index["SUBSCRIPTION_ADDON_DIGITAL_FORMS"] = 2] = "SUBSCRIPTION_ADDON_DIGITAL_FORMS";
    SubscriptionAddOnEnums_index[SubscriptionAddOnEnums_index["SUBSCRIPTION_ADDON_PRACTICE_ANALYTICS"] = 3] = "SUBSCRIPTION_ADDON_PRACTICE_ANALYTICS";
    SubscriptionAddOnEnums_index[SubscriptionAddOnEnums_index["SUBSCRIPTION_ADDON_WEAVE_VERIFY"] = 4] = "SUBSCRIPTION_ADDON_WEAVE_VERIFY";
    SubscriptionAddOnEnums_index[SubscriptionAddOnEnums_index["SUBSCRIPTION_ADDON_CALL_INTELLIGENCE"] = 5] = "SUBSCRIPTION_ADDON_CALL_INTELLIGENCE";
    SubscriptionAddOnEnums_index[SubscriptionAddOnEnums_index["SUBSCRIPTION_ADDON_TEXT_CONNECT"] = 6] = "SUBSCRIPTION_ADDON_TEXT_CONNECT";
    SubscriptionAddOnEnums_index[SubscriptionAddOnEnums_index["SUBSCRIPTION_ADDON_BULK_MESSAGING"] = 7] = "SUBSCRIPTION_ADDON_BULK_MESSAGING";
})(SubscriptionAddOnEnums_index || (SubscriptionAddOnEnums_index = {}));
// SubscriptionAddOnStatus helps in determining the Trial and Feature status chip in UI. 
export var SubscriptionAddOnStatus;
(function (SubscriptionAddOnStatus) {
    SubscriptionAddOnStatus["ADDON_STATUS_UNSPECIFIED"] = "ADDON_STATUS_UNSPECIFIED";
    SubscriptionAddOnStatus["ACTIVE"] = "ACTIVE";
    SubscriptionAddOnStatus["FREE_TRIAL_ACTIVE"] = "FREE_TRIAL_ACTIVE";
    SubscriptionAddOnStatus["FREE_TRIAL_ELIGIBLE"] = "FREE_TRIAL_ELIGIBLE";
})(SubscriptionAddOnStatus || (SubscriptionAddOnStatus = {}));
export var SubscriptionAddOnStatus_index;
(function (SubscriptionAddOnStatus_index) {
    SubscriptionAddOnStatus_index[SubscriptionAddOnStatus_index["ADDON_STATUS_UNSPECIFIED"] = 0] = "ADDON_STATUS_UNSPECIFIED";
    SubscriptionAddOnStatus_index[SubscriptionAddOnStatus_index["ACTIVE"] = 1] = "ACTIVE";
    SubscriptionAddOnStatus_index[SubscriptionAddOnStatus_index["FREE_TRIAL_ACTIVE"] = 2] = "FREE_TRIAL_ACTIVE";
    SubscriptionAddOnStatus_index[SubscriptionAddOnStatus_index["FREE_TRIAL_ELIGIBLE"] = 3] = "FREE_TRIAL_ELIGIBLE";
})(SubscriptionAddOnStatus_index || (SubscriptionAddOnStatus_index = {}));
export var SubscriptionStatusForSelfUpgrade;
(function (SubscriptionStatusForSelfUpgrade) {
    SubscriptionStatusForSelfUpgrade["SUBSCRIPTION_STATUS_UNSPECIFIED"] = "SUBSCRIPTION_STATUS_UNSPECIFIED";
    SubscriptionStatusForSelfUpgrade["SCHEDULE_CALL"] = "SCHEDULE_CALL";
    SubscriptionStatusForSelfUpgrade["SUBSCRIBE"] = "SUBSCRIBE";
})(SubscriptionStatusForSelfUpgrade || (SubscriptionStatusForSelfUpgrade = {}));
export var SubscriptionStatusForSelfUpgrade_index;
(function (SubscriptionStatusForSelfUpgrade_index) {
    SubscriptionStatusForSelfUpgrade_index[SubscriptionStatusForSelfUpgrade_index["SUBSCRIPTION_STATUS_UNSPECIFIED"] = 0] = "SUBSCRIPTION_STATUS_UNSPECIFIED";
    SubscriptionStatusForSelfUpgrade_index[SubscriptionStatusForSelfUpgrade_index["SCHEDULE_CALL"] = 1] = "SCHEDULE_CALL";
    SubscriptionStatusForSelfUpgrade_index[SubscriptionStatusForSelfUpgrade_index["SUBSCRIBE"] = 2] = "SUBSCRIBE";
})(SubscriptionStatusForSelfUpgrade_index || (SubscriptionStatusForSelfUpgrade_index = {}));
export var TrialStatus;
(function (TrialStatus) {
    TrialStatus["TRIAL_STATUS_UNSPECIFIED"] = "TRIAL_STATUS_UNSPECIFIED";
    TrialStatus["TRIAL_ELIGIBLE"] = "TRIAL_ELIGIBLE";
    TrialStatus["TRIAL_ACTIVE"] = "TRIAL_ACTIVE";
})(TrialStatus || (TrialStatus = {}));
export var TrialStatus_index;
(function (TrialStatus_index) {
    TrialStatus_index[TrialStatus_index["TRIAL_STATUS_UNSPECIFIED"] = 0] = "TRIAL_STATUS_UNSPECIFIED";
    TrialStatus_index[TrialStatus_index["TRIAL_ELIGIBLE"] = 1] = "TRIAL_ELIGIBLE";
    TrialStatus_index[TrialStatus_index["TRIAL_ACTIVE"] = 2] = "TRIAL_ACTIVE";
})(TrialStatus_index || (TrialStatus_index = {}));
export const SubscriptionManagerService = {
    // Subscribe will activate subscription for a given locationID and featureID(optional) or featureEnum via Salesforce
    Subscribe(fn, req) {
        return fn(`/subscription-manager-service/v1/subscribe`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    // GetSubscriptionAddOnsStatuses will give details for cards to be rendered on Subscription pages with free trial icon. 
    GetSubscriptionAddOnsStatuses(fn, req) {
        return fn(`/subscription-manager-service/v1/subscription/addons?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    // IsEligibleForSelfUpgradeOrTrial helps in indentifying whether to show self signup subscribe option or not. 
    IsEligibleForSelfUpgradeOrTrial(fn, req) {
        return fn(`/subscription-manager-service/v1/subscription/addon/status?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    // IsEligibleForSelfUpgradeOrTrial helps in indentifying whether to show self signup subscribe option or not. 
    NotifyAdminForUpgrade(fn, req) {
        return fn(`/subscription-manager-service/v1/subscription/notify-admin`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    // this endpoint will be used to self-serve multiple location in one request 
    MultiSubscribe(fn, req) {
        return fn(`/subscription-manager-service/v1/subscribe/multi`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    // IsEligibleForSelfUpgradeOrTrial helps in indentifying whether to show self signup subscribe option or not. 
    IsMultiEligibleForSelfUpgradeOrTrial(fn, req) {
        return fn(`/subscription-manager-service/v1/subscription/multi/addon/status?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    GetSubscriptionAddOnsStatusesForMulti(fn, req) {
        return fn(`/subscription-manager-service/v1/subscription/multi/addons?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
};
